<ng-container *onlyForScreens="['desktop', 'tablet']">
  <ng-content></ng-content>
</ng-container>

<button
  appButton
  [name]="name"
  [location]="location"
  height="1"
  color="simple-gray"
  shape="round"
  [iconButton]="true"
  [class.disabled]="disabled"
  *onlyForScreens="['mobile']"
>
  <app-svg src="/assets/icons/edit.svg"></app-svg>
</button>
